/**
 * Copyright Mántum All Rights Reserved.
 */

type PropTypes = {
    children?: React.ReactNode;
    top?: number | string;
};

export default function Column(props: PropTypes) {
    return (
        <div
            className='fixed bottom-0 right-0 z-30 flex w-full px-4 py-6 sm:bottom-auto sm:top-0 sm:w-[440px] sm:items-start sm:p-6'
            style={{ marginTop: props.top }}
        >
            <div className='flex w-full flex-col items-center gap-4 sm:items-end'>
                {props.children}
            </div>
        </div>
    );
}
